import { FC } from 'react';
import styles from './Breadcrumbs.module.scss';
import Link from 'next/link';

interface IBreadcrumbs {
  firstPageName: string;
  secondPageName?: string;
  thirdPageName?: string;
  fourthPageName?: string;
  firstPageAlias?: string;
  secondPageAlias?: string;
  thirdPageAlias?: string;
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ firstPageName, secondPageName, thirdPageName, fourthPageName, thirdPageAlias, firstPageAlias, secondPageAlias }) => {
  return (
    <div className={styles.breadcrumbsListWrap}>
      <ul className={styles.breadcrumbsList}>
        <li className={styles.breadcrumbsList__item}>
          <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href="/">
            Главная
          </Link>
        </li>
        <li className={styles.breadcrumbsList__item}>
          {!!firstPageAlias ? (
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`${firstPageAlias}`}>
              {firstPageName}
            </Link>
          ) : (
            <>{firstPageName}</>
          )}
        </li>
        {!!secondPageName && (
          <li className={styles.breadcrumbsList__item}>
            {!!secondPageAlias ? (
              <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`${secondPageAlias}`}>
                {secondPageName}
              </Link>
            ) : (
              <>{secondPageName}</>
            )}
          </li>
        )}
        {!!thirdPageName && (
          <li className={styles.breadcrumbsList__item}>
            {!!thirdPageAlias ? (
              <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`${thirdPageAlias}`}>
                {thirdPageName}
              </Link>
            ) : (
              <>{thirdPageName}</>
            )}
          </li>
        )}
        {!!fourthPageName && (
          <li className={styles.breadcrumbsList__item}>
            <span className={styles.breadcrumbsList__itemTxt}>{fourthPageName}</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
